export default "__VITE_ASSET__DbYRR23x__"